import { render } from "./UserProfileInfo.vue?vue&type=template&id=1c2c1433&scoped=true"
import script from "./UserProfileInfo.vue?vue&type=script&lang=js"
export * from "./UserProfileInfo.vue?vue&type=script&lang=js"

import "./UserProfileInfo.vue?vue&type=style&index=0&id=1c2c1433&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2c1433"]])

export default __exports__